import React, { useEffect, useState } from "react";
import "./contactusbanner.css";

import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";

const ContactUsBanner = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="contactusbanner">
        <Banner page="contact" />

    </section>
  );
};

export default ContactUsBanner;
